import { DOCUMENT } from '@angular/common';
import { inject, Injectable, OnDestroy } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import AppValues from '../common/app.values';

const MEDIA_QUERY_CONDITION = 'max-width';
const DEFAULT_MOBILE_BREAKPOINT: number = AppValues.DEFAULT_WIDTH_FOR_MOBILE;

@Injectable({ providedIn: 'root' })
export class MediaQueryService implements OnDestroy {
  private readonly MOBILE_MEDIA_QUERY: string = `(${MEDIA_QUERY_CONDITION}: ${DEFAULT_MOBILE_BREAKPOINT}px)`;

  private document: Document = inject(DOCUMENT);
  private matches$$: ReplaySubject<boolean> = new ReplaySubject<boolean>();

  public constructor() {
    this.registerListener();
  }

  public ngOnDestroy(): void {
    this.removeListener();
    this.matches$$.complete();
  }

  public get match$(): Observable<boolean> {
    return this.matches$$.asObservable();
  }

  private registerListener(): void {
    if (this.document.defaultView) {
      const mediaQueryList: MediaQueryList = this.document.defaultView.matchMedia(this.MOBILE_MEDIA_QUERY);

      this.matches$$.next(mediaQueryList.matches);

      const listener: (event: MediaQueryListEvent) => void = (event: MediaQueryListEvent) => {
        this.matches$$.next(event.matches);
      };

      mediaQueryList.addEventListener('change', listener);

      this.removeListener = () => {
        mediaQueryList.removeEventListener('change', listener);
      };
    }
  }

  private removeListener: () => void = () => {
    // ignore
  };
}
